import { AbstractService } from '@uniqoders/sdk';

export default class FaqCategoryService extends AbstractService {
  /**
   * Retrieve paginated FAQ categories for an agency
   */
  public listCmsFaqCategories(agency: string, params: Record<string, any> = {}): Promise<any> {
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/faq-categories', { agency }),
      params,
    });
  }

  /**
   * Retrieve a single FAQ category
   */
  public getCmsFaqCategory(agency: string, cmsFaqCategoryId: number, options: Record<string, any> = {}): Promise<any> {
    const { headers, params } = options;
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/faq-categories/{cmsFaqCategoryId}', { agency, cmsFaqCategoryId }),
      params,
      headers,
    });
  }

  /**
   * Create a new FAQ category
   */
  public createCmsFaqCategory(agency: string, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/faq-categories', { agency }),
      data,
    });
  }

  /**
   * Update an existing FAQ category
   */
  public updateCmsFaqCategory(agency: string, cmsFaqCategoryId: number, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'patch',
      url: this.buildPath('/v2/{agency}/cms/faq-categories/{cmsFaqCategoryId}', { agency, cmsFaqCategoryId }),
      data,
    });
  }

  /**
   * Delete a FAQ category
   */
  public deleteCmsFaqCategory(agency: string, cmsFaqCategoryId: number): Promise<any> {
    return this.request({
      method: 'delete',
      url: this.buildPath('/v2/{agency}/cms/faq-categories/{cmsFaqCategoryId}', { agency, cmsFaqCategoryId }),
    });
  }

  /**
   * Publish or unpublish a FAQ category
   */
  public publishCmsFaqCategory(
    agency: string,
    cmsFaqCategoryId: number,
    data: { is_public: boolean },
  ): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/faq-categories/{cmsFaqCategoryId}/publish', { agency, cmsFaqCategoryId }),
      data,
    });
  }
}

